import {Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-warehouse-transactions-inbound",
    template: `
        <section-warehouse-transactions-list [params]='{title: "Inbound transactions", type: "inbound", state: state}'>
        </section-warehouse-transactions-list>`
})
export class WarehouseTransactionsListInboundComponent implements Base.IComponent {

    public readonly state: Base.IState;

    public ngConfig(): Base.IConfig {
        return {
            name: "transactions-inbound",
            actions: {
                "browse": ["browse_warehouse_transactions"]
            }
        };
    }

}
